module.exports = __webpack_public_path__ + "static/media/starshipit1.79baf8af.jpg";